var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBathroom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_05",
    "data-name": 5,
    transform: "translate(-499 -56.076)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2689",
    "data-name": "Rectangle 2689",
    width: 112,
    height: 112,
    rx: 21,
    transform: "translate(499 56.076)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "water-closet",
    transform: "translate(484.201 81.746)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12640",
    "data-name": "Path 12640",
    d: "M57.826,72.159l-3.661.929-3.378-.929H49.307A3.211,3.211,0,0,1,46.1,68.948V52.681l7.437-3.063,7.437,3.063V69.015A3.145,3.145,0,0,1,57.826,72.159Z",
    transform: "translate(0 -43.562)",
    fill: "#d8ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12641",
    "data-name": "Path 12641",
    d: "M119.386,68.654l-1.563.74V85.727a3.145,3.145,0,0,1-3.145,3.145l1.544.461,1.815-.461a3.145,3.145,0,0,0,3.145-3.145V69.394Z",
    transform: "translate(-60.212 -60.274)",
    fill: "#989fd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12642",
    "data-name": "Path 12642",
    d: "M118.162,340.92l2.3,5.1-2.3,5.1h-5.644a2.089,2.089,0,0,1-2.088-2.089v-6.031a2.088,2.088,0,0,1,2.088-2.088Z",
    transform: "translate(-56.482 -299.31)",
    fill: "#365e7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12643",
    "data-name": "Path 12643",
    d: "M149.619,340.92l2.3,5.1-2.3,5.1H146.26V340.92Z",
    transform: "translate(-87.939 -299.31)",
    fill: "#2b4d66"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10565",
    "data-name": "Group 10565",
    transform: "translate(56.899 45.798)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12644",
    "data-name": "Path 12644",
    d: "M140.307,376.155a.916.916,0,0,1-.915.915h-3.867a.915.915,0,0,1,0-1.831h3.867A.915.915,0,0,1,140.307,376.155Z",
    transform: "translate(-134.61 -375.24)",
    fill: "#b3dafe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12645",
    "data-name": "Path 12645",
    d: "M150.535,376.155a.916.916,0,0,1-.915.915h-3.36V375.24h3.36A.915.915,0,0,1,150.535,376.155Z",
    transform: "translate(-144.838 -375.24)",
    fill: "#a4c7ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12646",
    "data-name": "Path 12646",
    d: "M177.756,294.067a1.908,1.908,0,0,1-1.589,2.966h-27.49a1.909,1.909,0,0,1-1.739-2.694l1.742-3.856a5.285,5.285,0,0,0,.466-2.171v-9.885a5.274,5.274,0,0,0-.624-2.49l-2.8-5.23,17.2-1.474,16.812,1.474c0,10.151-5.291,13.119-7.332,13.886a.643.643,0,0,0-.312.959l.58.87Z",
    transform: "translate(-87.465 -236.374)",
    fill: "#d8ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12647",
    "data-name": "Path 12647",
    d: "M344.519,297.363a1.908,1.908,0,0,1-1.589,2.966h-3.012a1.908,1.908,0,0,0,1.588-2.966l-5.738-7.872a.677.677,0,0,1,.312-.959c2.1-1.233,7.4-4.377,7.4-14.528l1.5-1.016L346.494,274c0,10.151-5.291,13.119-7.332,13.886a.643.643,0,0,0-.312.959Z",
    transform: "translate(-254.229 -239.67)",
    fill: "#989fd7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10566",
    "data-name": "Group 10566",
    transform: "translate(77.663 48.22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12648",
    "data-name": "Path 12648",
    d: "M312.272,396.91l-6.444,1.355a.906.906,0,0,1-.179.018.916.916,0,0,1-.179-1.814L312,395.08a.643.643,0,0,0-.312.959Z",
    transform: "translate(-304.734 -395.08)",
    fill: "#989fd7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12649",
    "data-name": "Path 12649",
    d: "M106.084,240.043H63.744a2.616,2.616,0,0,1-2.616-2.616v-.265a2.856,2.856,0,0,1,2.856-2.856H106.17a2.53,2.53,0,0,1,2.53,2.53v.59A2.616,2.616,0,0,1,106.084,240.043Z",
    transform: "translate(-13.197 -205.71)",
    fill: "#6a75b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12650",
    "data-name": "Path 12650",
    d: "M405.392,234.308h-3.359a2.53,2.53,0,0,1,2.53,2.53v.59a2.616,2.616,0,0,1-2.616,2.616h3.359a2.616,2.616,0,0,0,2.616-2.616v-.59A2.53,2.53,0,0,0,405.392,234.308Z",
    transform: "translate(-312.42 -205.71)",
    fill: "#989fd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12651",
    "data-name": "Path 12651",
    d: "M60.97,9.12H46.1V6.227a6.224,6.224,0,0,1,7.443-6.1L58.9,1.194a2.574,2.574,0,0,1,2.07,2.524Z",
    transform: "translate(0 0)",
    fill: "#989fd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12652",
    "data-name": "Path 12652",
    d: "M91.843,1.2,86.481.127a6.19,6.19,0,0,0-2.863.1l4.866.972a2.574,2.574,0,0,1,2.07,2.524v5.4h3.359v-5.4A2.574,2.574,0,0,0,91.843,1.2Z",
    transform: "translate(-32.942 -0.004)",
    fill: "#6a75b9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10567",
    "data-name": "Group 10567",
    transform: "translate(51.583 3.371)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12653",
    "data-name": "Path 12653",
    d: "M94.572,29.45H91.965a.915.915,0,0,1,0-1.831h2.606a.915.915,0,0,1,0,1.831Z",
    transform: "translate(-91.05 -27.619)",
    fill: "#365e7d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10572",
    "data-name": "Group 10572",
    transform: "translate(67.269 9.454)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10568",
    "data-name": "Group 10568",
    transform: "translate(4.979)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12654",
    "data-name": "Path 12654",
    d: "M261.282,82.227a.915.915,0,0,1-.915-.915V78.368a.915.915,0,0,1,1.831,0v2.943A.915.915,0,0,1,261.282,82.227Z",
    transform: "translate(-260.367 -77.453)",
    fill: "#ff9100"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10569",
    "data-name": "Group 10569",
    transform: "translate(4.979 7.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12655",
    "data-name": "Path 12655",
    d: "M261.282,139.7a.915.915,0,0,1-.915-.915v-2.943a.915.915,0,1,1,1.831,0v2.943A.915.915,0,0,1,261.282,139.7Z",
    transform: "translate(-260.367 -134.923)",
    fill: "#ff9100"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10570",
    "data-name": "Group 10570",
    transform: "translate(7.014 4.979)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12656",
    "data-name": "Path 12656",
    d: "M280.9,120.076H277.96a.915.915,0,1,1,0-1.831H280.9a.915.915,0,0,1,0,1.831Z",
    transform: "translate(-277.045 -118.245)",
    fill: "#ff9100"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10571",
    "data-name": "Group 10571",
    transform: "translate(0 4.979)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12657",
    "data-name": "Path 12657",
    d: "M223.433,120.076H220.49a.915.915,0,1,1,0-1.831h2.943a.915.915,0,0,1,0,1.831Z",
    transform: "translate(-219.575 -118.245)",
    fill: "#ff9100"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10573",
    "data-name": "Group 10573",
    transform: "translate(80.589 8.224)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12658",
    "data-name": "Path 12658",
    d: "M333.7,155.484h-1.12v-1.12a.915.915,0,1,0-1.831,0v1.12h-1.12a.915.915,0,1,0,0,1.831h1.12v1.12a.915.915,0,0,0,1.831,0v-1.12h1.12a.915.915,0,1,0,0-1.831Z",
    transform: "translate(-328.715 -142.944)",
    fill: "#ff9100"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_373",
    "data-name": "Ellipse 373",
    cx: 0.896,
    cy: 0.896,
    r: 0.896,
    transform: "translate(4.986)",
    fill: "#ff9100"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBathroom);
export default __webpack_public_path__ + "static/media/bathroom.0b182a05c562c2ea52ed3072470ce0d8.svg";
export { ForwardRef as ReactComponent };